import moment from "moment";

const formValidationRules = {
    today: moment(),
    eighteenYearsAgo: moment().subtract(18, 'years'),
}

export default formValidationRules;